






















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import Card from '@/components/Card/index.vue'
import ProductList from '@/components/ProductList/index.vue'
import Tabs from '@/components/Tabs/index.vue'
import NewBusi from './components/NewBusi/index.vue'
import Merchant from './components/Merchant/index.vue'
import { hot, newData, adInfo, reconnentList, earn } from '@/api/home'
import { custProductTypies } from '@/api/com'
import { userInfoTypes, UserStore } from '@/store/modules/User'
import { AdInfoType } from '@/api/type-res'
import { CityStore, cityInfoTypes } from '@/store/modules/NavCity'
import { BaseStore } from '@/store/modules/Base'

let vm:any

@Component({
  components: {
    swiper: Swiper,
    'swiper-slide': SwiperSlide,
    Card,
    Tabs,
    ProductList,
    NewBusi,
    Merchant
  },
  directives: {
    swiper: directive
  }
})
export default class Home extends Vue {
  // 轮播图配置
  private swiperOptions = {
    updateOnWindowResize: true, // 默认当窗口(window) 尺寸发生变化时，比如屏幕旋转，Swiper会更新和重新计算
    width: window.innerWidth, // 设置宽度为全屏
    // height: 300, // 你的slide高度
    observer: true, // 修改swiper自己或子元素时，自动初始化swiper
    observeParents: true, // 修改swiper的父元素时，自动初始化swiper
    // loop: true, // 循环模式选项
    effect: 'fade',
    autoplay: {
      delay: 5000,
      stopOnLastSlide: false,
      disableOnInteraction: false
    },
    grabCursor: true, // 手掌
    preventClicksPropagation: true, // 阻止click冒泡。拖动Swiper时阻止click事件。
    // lazy: true,
    // 如果需要分页器
    pagination: {
      el: '.swiper-pagination',
      bulletClass: 'my-bullet',
      bulletActiveClass: 'my-bullet-active'
    },
    on: {
      click: () => {
        const mySwiper:any = this.$refs.mySwiper
        const index = mySwiper.swiperInstance.activeIndex
        const link = vm.adInfoList[index].link
        if (/^http/.test(link)) {
          window.open(link)
        } else {
          vm.$router.push(link)
        }
      }
    }
    // 如果需要前进后退按钮
    // navigation: {
    //   nextEl: '.swiper-button-next',
    //   prevEl: '.swiper-button-prev'
    // }
  }

  private adInfoList: Array<AdInfoType> = []
  // private adInfoListLoading = true

  // 卡片宽度
  private cardWidth: string | number = 380

  // Tabs数据
  private tabList = []

  // 默认为抢购激活抢购类型
  private tabsActive: number | string = 12

  // 最热
  private hotList:any[] = []
  // 最热 加载状态
  private hotLoading = true

  // 最新
  private newList:any[] = []
  // 最热 加载状态
  private newLoading = true

  // 最赚
  private earnList:any[] = []
  // 最赚 加载状态
  private earnLoading = true

  // 推荐产品
  private reconnentList: any[] = []
  private productLoading = true

  private areaId: number | string = ''

  get UserInfo (): userInfoTypes {
    return UserStore.userInfo
  }

  // 获取导航栏选中的城市
  get CityInfo (): cityInfoTypes {
    return CityStore.cityInfo
  }

  // 监听导航栏城市改变，更新列表
  @Watch('CityInfo')
  CityInfoChanged (news: any) {
    this.areaId = news.areaId
    this.getAdInfo()
    this.getReconnentList()
  }

  // Tabs切换
  private changeTabsItem (id: number | string): void {
    // console.log(id)
    this.tabsActive = id
    this.getReconnentList()
  }

  // 最热产品
  private getHot (): void {
    hot()
      .then((res: any) => {
        this.hotLoading = false
        if (res && res.results) {
          this.hotList = res.results.splice(0, 5)
        }
      })
  }

  // 最新产品
  private getNew (): void {
    newData()
      .then((res: any) => {
        this.newLoading = false
        if (res && res.results) {
          this.newList = res.results.splice(0, 5)
        }
      })
  }

  // 最赚
  private getEarn () {
    earn()
      .then(res => {
        this.earnLoading = false
        if (res && res.results) {
          this.earnList = res.results.splice(0, 5)
        }
      })
  }

  // 获取产品类型-分类
  private getCustProductTypies ():void {
    custProductTypies()
      .then((res: any) => {
        if (res) {
          this.tabList = res
        }
      })
  }

  // 获取首页广告
  private getAdInfo (): void {
    const params = {
      page: 0,
      resultNum: 6,
      areaId: this.areaId
    }
    adInfo(params)
      .then((res) => {
        if (res && res.length) {
          this.adInfoList = res.slice(1, 6)
          BaseStore.SET_SCROLL_TOP(250)
        } else {
          BaseStore.SET_SCROLL_TOP(0)
        }
      })
  }

  // 推荐产品
  private getReconnentList () {
    this.productLoading = true
    const params = {
      treeId: this.tabsActive,
      areaId: this.areaId
    }
    reconnentList(params)
      .then(res => {
        this.productLoading = false
        if (res.success) {
          this.reconnentList = res.data.results
        }
      })
  }

  // 点击广告位
  private clickAdInfo (item): void {
    window.open(item.link)
  }

  // 轮播图左按钮
  private handlePrev (): void {
    (this.$refs.mySwiper as any).$swiper.slidePrev()
  }

  // 轮播图右按钮
  private handleNext (): void {
    (this.$refs.mySwiper as any).$swiper.slideNext()
  }

  mounted ():void {
    vm = this
    if (document.body.offsetWidth <= 768) {
      this.cardWidth = '100%'
    }
    this.areaId = this.UserInfo.areaId as number
    this.getHot()
    this.getNew()
    this.getEarn()
    this.getCustProductTypies()
    this.getAdInfo()
    this.getReconnentList()
  }
}
